import {useCookies} from "vue3-cookies";
import {getHost} from "@/hooks/fnHelper";

export default function deleteNonValidCookie() {
    const {cookies} = useCookies();
    if (location.pathname !== '/') {
        const host = getHost();
        console.log('deleteNonValidCookie host', host)
        cookies.remove('server_sid', location.pathname.replace(/\/$/, ''), host);
        cookies.remove('server_sid', location.pathname.replace(/\/$/, '') + '/', host);
        cookies.remove('server_sid', location.pathname.replace(/\/$/, ''), 'market.polyanaski.ru');
        cookies.remove('server_sid', location.pathname.replace(/\/$/, '') + '/', 'market.polyanaski.ru');
        cookies.remove('xaccountuid', location.pathname.replace(/\/$/, ''), host);
        cookies.remove('xaccountuid', location.pathname.replace(/\/$/, '') + '/', host);
        cookies.remove('xaccountuid', location.pathname.replace(/\/$/, ''), 'market.polyanaski.ru');
        cookies.remove('xaccountuid', location.pathname.replace(/\/$/, '') + '/', 'market.polyanaski.ru');

        deleteCookieWithPath('server_sid', location.pathname.replace(/\/$/, ''));
        deleteCookieWithPath('server_sid', location.pathname.replace(/\/$/, '') + '/');
        deleteCookieWithPath('xaccountuid', location.pathname.replace(/\/$/, ''));
        deleteCookieWithPath('xaccountuid', location.pathname.replace(/\/$/, '') + '/');
        if(host !== 'localhost') {
            deleteCookieWithPath('server_sid', '/');
            deleteCookieWithPath('xaccountuid', '/');
        }
    }
}

function deleteCookieWithPath(name, path) {
    document.cookie = `${name}=; path=${path}; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
}